import React, { useEffect, useState } from "react"

import useDeviceDetection from "../../hooks/useDeviceDetection"
import useWindowSize from "../../hooks/useWindowSize"
import AppointmentConversionProofNotification from "../HomePageV2Landing/components/AppointmentConversionProofNotification"
import AppointmentSocialProofNotification from "../HomePageV2Landing/components/AppointmentSocialProofNotification"

import ClosingSection from "./sections/ClosingSection"
import HeroSection from "./sections/HeroSection"
import ReviewsSection from "./sections/ReviewsSection"

const ProExperiencePage = (props) => {
  const { isMobile: isMobileDeviceDetection, width: deviceDetectionWidth } = useDeviceDetection(1080)
  const { isMobile: isMobileWindowSize, width: windowSizeWidth } = useWindowSize(1080)
  const [hasMounted, setHasMounted] = useState(false)

  useEffect(() => setHasMounted(true), [])

  const determineIsMobile = () => {
    if (!hasMounted) return false
    const width = windowSizeWidth !== null && windowSizeWidth !== undefined ? windowSizeWidth : deviceDetectionWidth
    if (width === null || width === undefined) return false
    if (isMobileDeviceDetection === isMobileWindowSize) return isMobileDeviceDetection
    if (isMobileWindowSize) return true
    if (isMobileDeviceDetection) return true
    return false
  }

  const isMobile = determineIsMobile()

  return (
    <div className="pro-experience-page">
      {props.showSocialProofNotifications && hasMounted && (
        <>
          <AppointmentConversionProofNotification isMobile={isMobile} />
          <AppointmentSocialProofNotification isMobile={isMobile} />
        </>
      )}
      <HeroSection
        nextAvailableTime={props.nextAvailableTime}
        title={props.heroTitle}
        titleFontSize={props.heroTitleFontSize}
        titleMobileFontSize={props.heroMobileTitleFontSize}
        titleWidth={props.heroTitleWidth}
        subtitle={props.heroSubtitle}
        heroBullets={props.heroBullets}
        formTitle={props.formTitle}
        formButtonText={props.formButtonText}
        checkboxText={props.checkboxText}
        showDemoFormSubtitle={props.showDemoFormSubtitle}
        demoFormSubtitleLine1={props.demoFormSubtitleLine1}
        demoFormSubtitleLine2={props.demoFormSubtitleLine2}
        fireDemoScheduledEvent={props.fireDemoScheduledEvent}
      />
      <ReviewsSection reviews={props.reviews || []} />
      <ClosingSection formButtonText={props.formButtonText} />
    </div>
  )
}

export default ProExperiencePage
